export default class AnimatedCounter {
    constructor() {
        this.init();
    }

    init() {
        const counters = document.querySelectorAll('.js-animated-counter');
        
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    this.animateCounter(entry.target);
                    observer.unobserve(entry.target);
                }
            });
        }, {
            threshold: 0.5
        });
        
        counters.forEach(counter => {
            observer.observe(counter);
        });
    }

    formatNumber(number) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "'");
    }

    animateCounter(counter) {
        const startingValue = parseInt(counter.dataset.startingValue);
        const targetValue = parseInt(counter.dataset.targetValue);
        
        // Check if both values are valid integers
        if (isNaN(startingValue) || isNaN(targetValue)) {
            return;
        }
        
        const duration = 2000;
        const startTime = performance.now();
        
        const animate = (currentTime) => {
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / duration, 1);
            
            // Easing function for smooth animation
            const easeOutQuart = 1 - Math.pow(1 - progress, 4);
            
            const currentValue = Math.floor(startingValue + (targetValue - startingValue) * easeOutQuart);
            const formattedValue = this.formatNumber(currentValue);
            
            // Update only the counter value span
            const counterValueSpan = counter.querySelector('.counter-value');
            counterValueSpan.textContent = formattedValue;
            
            if (progress < 1) {
                requestAnimationFrame(animate);
            }
        };
        
        requestAnimationFrame(animate);
    }
} 